/**
 * Whether this document is rendering inside an iframe. Reaching window.top
 * can throw in sandboxed webviews, and only a framed document has a top it
 * cannot see, so a throw reads as framed.
 */
export const isFramed = (): boolean => {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}
